module.exports = __webpack_public_path__ + "static/media/small-box.5a3f6c20.svg";